(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('AlertRulesController', AlertRulesController);

    AlertRulesController.$inject = ['$uibModal', '$state', 'AlertRules', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'WarningConstant', 'domain', 'AlertSystem', '$rootScope', '$timeout'];

    function AlertRulesController($uibModal, $state, AlertRules, ParseLinks, AlertService, pagingParams, paginationConstants, WarningConstant, domain, AlertSystem, $rootScope, $timeout) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.loadSystemPage = loadSystemPage;
        vm.changePageSize = changePageSize;
        vm.tooggleStatus = tooggleStatus;
        vm.enableTooltip = enableTooltip;

        vm.predicates = pagingParams.predicates;
        vm.systemPredicates = pagingParams.systemPredicates;
        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;
        vm.currentState = "alert-rule";
        vm.systemWarningItemLimit = 4;
        var retrievedOrder = localStorage.getItem(vm.currentState);
        if (retrievedOrder != null && retrievedOrder !== "null") {
            vm.predicates = JSON.parse(retrievedOrder);

        }
        retrievedOrder = localStorage.getItem(vm.currentState + "system");
        if (retrievedOrder != null && retrievedOrder !== "null") {
            vm.systemPredicates = JSON.parse(retrievedOrder);

        }
        vm.selectedFleet = {};
        vm.selectedObjectType = {};
        vm.selectedCondition = {};
        vm.selectedFleet.id = pagingParams.fleet;
        vm.selectedObjectType.id = pagingParams.objectType;
        vm.fleet = {};
        vm.objectType = {};
        vm.selectedFleets = [];
        vm.applyFilter = applyFilter;
        vm.transition = transition;
        vm.loadAll();
        vm.enableMail = [];
        vm.enableTelegram = [];
        vm.enableWebhook = [];
        vm.wac = [];
        vm.licence = $rootScope.licence;
        vm.domain = domain;

        function enableTooltip(channel, id) {
            vm[channel][id].tooltip = true;
            $timeout(function () {
                vm[channel][id].tooltip = false;
            }, 2000);
        }

        function sort(predicates, type) {
            var sortFields = [];
            var keys = Object.keys(predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (predicates[predicate] ? 'asc' : 'desc'));
            }
            localStorage.setItem(vm.currentState + type, JSON.stringify(predicates));
            return sortFields;
        }

        function loadAll() {

            AlertRules.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPageChosen,
                fleet: vm.selectedFleet.id,
                objectType: vm.selectedObjectType.id,
                query: vm.charToSearch,
                sort: sort(vm.predicates, "")
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.warnings = data.warnings;
                vm.notifications = data.notification;
                vm.page = pagingParams.page;
                enableAlertSystem(vm.warnings);
                AlertSystem.getUserAlertSystem({user: 'logged'}, onAlertSuccess);
            }

            AlertRules.querySystem({
                page: pagingParams.systemPage - 1,
                size: vm.systemWarningItemLimit,
                fleet: vm.selectedFleet.id,
                sort: sort(vm.systemPredicates, "system")
            }, onSuccessSystem, onError);

            function onSuccessSystem(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.systemTotalItems = headers('X-Total-Count');
                vm.systemQueryCount = vm.systemTotalItems;
                vm.systemWarnings = data.warnings;
                vm.notifications = data.notification;
                vm.systemPage = pagingParams.systemPage;
                enableAlertSystem(vm.systemWarnings);
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function enableAlertSystem(warnings) {
            warnings.forEach(function (warning) {
                vm.wac[warning.id] = {};
                vm.wac[warning.id].email = false;
                vm.wac[warning.id].telegram = false;
                vm.wac[warning.id].webhook = false;
                warning.warningAlertConfigurations.forEach(function (wac) {
                    var name = wac.alertSystemType.name;
                    vm.wac[warning.id][name] = wac.active;
                });
                if (!(domain.enableAlerting && domain.mailAlerting))
                    warning.relatedAlertSystemType.Channelemail = vm.wac[warning.id].email = domain.enableAlerting && domain.mailAlerting;
                if (!(domain.enableAlerting && domain.telegramAlerting))
                    warning.relatedAlertSystemType.Channeltelegram = vm.wac[warning.id].telegram = domain.enableAlerting && domain.telegramAlerting;
                if (!(domain.enableAlerting && domain.webhookAlerting))
                    warning.relatedAlertSystemType.Channelwebhook = vm.wac[warning.id].webhook = domain.enableAlerting && domain.webhookAlerting;
                var enableMail = warning.relatedAlertSystemType.email != null && warning.relatedAlertSystemType.email != undefined && warning.relatedAlertSystemType.Channelemail != undefined && warning.relatedAlertSystemType.Channelemail && vm.wac[warning.id].email;
                var enableTelegram = warning.relatedAlertSystemType.telegram != null && warning.relatedAlertSystemType.telegram != undefined && warning.relatedAlertSystemType.Channeltelegram != undefined && warning.relatedAlertSystemType.Channeltelegram && vm.wac[warning.id].telegram;
                var enableWebhook = warning.relatedAlertSystemType.webhook != null && warning.relatedAlertSystemType.webhook != undefined && warning.relatedAlertSystemType.Channelwebhook != undefined && warning.relatedAlertSystemType.Channelwebhook && vm.wac[warning.id].webhook;
                vm.enableMail[warning.id] = vm.setWarningStatus(enableMail, domain.mailAlerting, vm.notifications.warningEmail, warning.relatedAlertSystemType.email, vm.wac[warning.id].email, warning.active);
                vm.enableTelegram[warning.id] = vm.setWarningStatus(enableTelegram, domain.telegramAlerting, vm.notifications.warningTelegram, warning.relatedAlertSystemType.telegram, vm.wac[warning.id].telegram, warning.active);
                vm.enableWebhook[warning.id] = vm.setWarningStatus(enableWebhook, domain.webhookAlerting, vm.notifications.warningWebhook, warning.relatedAlertSystemType.webhook, vm.wac[warning.id].webhook, warning.active);
            });
        }

        vm.setWarningStatus = function (enabled, domainNotification, userNotification, related, wac, warning) {
            var objToReturn = {status: false, config: {}, tooltip: false};
            if (enabled) {
                if (related && domainNotification === true && userNotification === true && warning === true) {
                    objToReturn.status = true;
                    objToReturn.config.color = 'color-green';
                } else {
                    objToReturn.status = true;
                    objToReturn.config.color = 'background-red';
                }
            } else objToReturn.config.color = 'color-grey';
            return objToReturn;
        }

        function onAlertSuccess(results) {
            vm.email = false;
            vm.telegram = false;
            vm.emailDisabled = false;
            vm.telegramDisabled = false;
            vm.webhookDisabled = false;
            results.forEach(function (alert) {
                if (alert.alertSystemType.name == "email") {
                    vm.email = true;
                    vm.userEmail = alert.actionIdentifier;
                    vm.emailDisabled = alert.adminDisabled;
                } else if (alert.alertSystemType.name == "telegram") {
                    vm.telegram = true;
                    vm.telegramDisabled = alert.adminDisabled;
                    vm.userTelegram = alert.actionIdentifier;
                } else if (alert.alertSystemType.name == "webhook") {
                    vm.webhook = true;
                    vm.webhookDisabled = alert.adminDisabled;
                    vm.userWebhok = alert.actionIdentifier;
                }
            });
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function loadSystemPage(page) {
            vm.systemPage = page;
            vm.transition();
        }

        function transition(notify) {
            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
                page: vm.page,
                predicates: vm.predicates,
                systemPredicates: vm.systemPredicates,
                sort: sort(vm.predicates, ""),
                systemPage: vm.systemPage,
                systemSort: sort(vm.systemPredicates, "system"),
                search: vm.charToSearch,
                itemsPerPageChosen: vm.itemsPerPageChosen,
                fleet: vm.selectedFleet.id,
                objectType: vm.selectedObjectType.id
            }, {notify: notify, location: "replace"});
        }

        vm.search = function () {
            pagingParams.page = 1;
            vm.loadAll();
            vm.transition(false);
        };


        function changePageSize() {
            if ((vm.queryCount / vm.itemsPerPageChosen) < pagingParams.page)
                vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            transition();
        }

        vm.changeProfile = function (warning) {
            $uibModal.open({
                templateUrl: 'app/entities/alert-rules/alert-rules-user-profile-dialog.html',
                controller: 'WarningUserProfileController',
                backdrop: 'static',
                controllerAs: 'vm',
                size: 'sm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('alertRules');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'AlertRules', function () {
                        return warning;
                    }]
                }
            });
        };

        vm.changeLevel = function (warning) {
            $uibModal.open({
                templateUrl: 'app/entities/alert-rules/alert-rules-level-dialog.html',
                controller: 'WarningLevelController',
                backdrop: 'static',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('alertRules');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'AlertRules', function () {
                        return warning;
                    }]
                }
            }).result.then(function () {
                transition(false);
            });
        };

        function tooggleStatus(warning) {
            if (!!warning.active) {
                $uibModal.open({
                    templateUrl: 'app/entities/alert-rules/alert-rules-turnoff-dialog.html',
                    controller: function ($uibModalInstance, entity) {
                        var vm = this;
                        vm.warning = entity;
                        vm.clear = clear;
                        vm.stop = stop;

                        function stop() {
                            $uibModalInstance.close();
                        }

                        function clear() {
                            $uibModalInstance.dismiss('cancel');
                        }
                    },
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('warning');
                            return $translate.refresh();
                        }],
                        entity: function () {
                            return warning;
                        }
                    }
                }).result.then(function () {
                    warning.active = !warning.active;
                    WarningConstant.update(warning, function () {
                        vm.loadAll();
                    });
                });
            } else {
                $uibModal.open({
                    templateUrl: 'app/entities/alert-rules/alert-rules-turnoff-dialog.html',
                    controller: function ($uibModalInstance, entity) {
                        var vm = this;
                        vm.warning = entity;
                        vm.clear = clear;
                        vm.stop = stop;

                        function stop() {
                            $uibModalInstance.close();
                        }

                        function clear() {
                            $uibModalInstance.dismiss('cancel');
                        }
                    },
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('warning');
                            return $translate.refresh();
                        }],
                        entity: function () {
                            return warning;
                        }
                    }
                }).result.then(function () {
                    warning.active = !warning.active;
                    WarningConstant.update(warning, function () {
                        vm.loadAll();
                    });
                });
            }
        }

        vm.openSettings = function (id) {
            $uibModal.open({
                templateUrl: 'app/entities/alert-rules/alert-rules-configuration.html',
                controller: 'AlertsConfigurationController',
                backdrop: 'static',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('alertRules');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'AlertRules', function ($stateParams, AlertRules) {
                        return AlertRules.get({id: id});
                    }]
                }
            }).result.then(function () {
                loadAll();
            });
        };

        vm.changeStatus = function (warning, type, notification, typeToCheck) {
            // check warning flags here to display proper modal
            if (typeToCheck.status && notification === true) {
                $uibModal.open({
                    templateUrl: 'app/entities/warning/modals/change-notification-channel.html',
                    controller: function ($uibModalInstance) {
                        var vm = this;
                        vm.clear = clear;
                        vm.stop = stop;
                        vm.warning = warning;
                        vm.type = type;
                        vm.notification = notification;

                        function stop() {
                            $uibModalInstance.close();
                        }

                        function clear() {
                            $uibModalInstance.dismiss('cancel');
                        }
                    },
                    backdrop: 'static',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('alertRules');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function () {
                    AlertRules.notifications({id: warning.id, type: type}, onChangeSuccess, onChangeError);
                });
            } else {
                vm.rerouteToSettings(vm.notifications, vm.domain, type, typeToCheck);
            }
        };

        vm.rerouteToSettings = function (userNotifications, domain, type, typeToCheck) {
            console.log(userNotifications, domain, type, typeToCheck)
            $uibModal.open({
                templateUrl: 'app/entities/warning/modals/reroute-modal.html',
                controller: function ($uibModalInstance) {
                    var vm = this;
                    vm.clear = clear;
                    vm.stop = stop;
                    vm.notification = null;
                    vm.warningCondition = null;
                    vm.domain = domain;
                    vm.type = type;
                    vm.typeToCheck = typeToCheck;
                    if (vm.domain.enableAlerting === true) {
                        if (type === 'email') {
                            vm.notification = userNotifications.warningEmail;
                            vm.warningCondition = vm.domain.mailAlerting;
                        } else if (type === 'telegram') {
                            vm.notification = userNotifications.warningTelegram;
                            vm.warningCondition = vm.domain.telegramAlerting;
                        } else {
                            vm.notification = userNotifications.warningWebhook;
                            vm.warningCondition = vm.domain.webhookAlerting;
                        }
                    } else {
                        vm.warningCondition = vm.domain.enableAlerting;
                    }
                    function stop() {
                        $uibModalInstance.close();
                    }

                    function clear() {
                        $uibModalInstance.dismiss('cancel');
                    }
                },
                backdrop: 'static',
                controllerAs: 'vm',
                size: 'md',
                resolve: {}
            }).result.then(function () {
                $state.go('general-settings');
            });
        };

        function onChangeSuccess(warning) {
            vm.warnings.forEach(function (warn) {
                if (warn.id == warning.id)
                    warn.relatedAlertSystemType = warning.relatedAlertSystemType;
            });
            enableAlertSystem(vm.warnings);
            vm.systemWarnings.forEach(function (warn) {
                if (warn.id == warning.id)
                    warn.relatedAlertSystemType = warning.relatedAlertSystemType;
            });
            enableAlertSystem(vm.systemWarnings);
        }

        function onChangeError() {

        }

        function applyFilter(fleet, objectType) {
            if (fleet.id) {
                if (fleet.id > 0)
                    vm.fleet = fleet;
                else {
                    vm.fleet = [];
                    vm.fleet = vm.selectedFleets;
                }
            } else
                vm.fleet.id = -1;
            if (objectType.id)
                vm.objectType = objectType;
            else
                vm.objectType.id = -1;
            vm.loadAll();
        }

        vm.notificationsHelp = function () {
            $uibModal.open({
                templateUrl: 'app/entities/alert-rules/notifications-help.html',
                controller: 'NotificationsHelpController',
                controllerAs: 'vm',
                size: 'md',
            }).result.then(function () {
                $state.go('warning');
            });
        };
    }
})();
